var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('OrdersIResaList',{attrs:{"customer":_vm.content}}),_c('OrdersAlphaList',{attrs:{"customer":_vm.content}}),_c('ReferralCodesList',{attrs:{"customer":_vm.content}}),_c('ReferralsList',{attrs:{"customer":_vm.content}}),_c('AllowedProducts',{attrs:{"customer":_vm.content}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }